import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MyLibraryMusicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"my_library_music"}/>
}
